import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC40x19KvftdWS_PTQab4Reyj1VHbn6_t4",
  authDomain: "gadimitra-3d8e5.firebaseapp.com",
  projectId: "gadimitra-3d8e5",
  storageBucket: "gadimitra-3d8e5.firebasestorage.app",
  messagingSenderId: "905723234572",
  appId: "1:905723234572:web:41de6bdb99f76094846129",
  measurementId: "G-298FSBWN04"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);